import React, { Component } from 'react';
import Radium from 'radium';
import { bool, string, shape } from 'prop-types';
import { connect } from 'react-redux';
import { push } from 'connected-react-router';
import { submit, destroy, isInvalid, hasSubmitFailed } from 'redux-form';
import { UTLabel } from '@widergy/energy-ui';

import { actionCreators as accountActions, accountPropTypes } from 'redux/accountHandlers';
import { gaTrackPageView } from 'services/AnalyticsService';
import { ROUTES } from 'constants/routes';
import { message } from 'utils/stringUtils';
import { SOCIAL_RATE_QUERY } from 'constants/reduxForms';
import { appConfig } from 'config/customization';

import SocialRateScene from './layout';
import styles from './styles';

class SocialRateContainer extends Component {
  state = { modalIsOpen: false };

  componentDidMount() {
    if (this.props.isPublicRequest) gaTrackPageView(ROUTES.PUBLIC_SOCIAL_RATE);
    else gaTrackPageView(ROUTES.SOCIAL_RATE);
  }

  handleQueryButtonClick = () =>
    appConfig.socialRate.externalSearchLink
      ? window.open(appConfig.socialRate.externalSearchLink)
      : this.setState({ modalIsOpen: true });

  handleQueryModalClose = () => {
    this.setState({ modalIsOpen: false });
    this.props.dispatch(accountActions.clearSocialRateStatus());
    this.props.dispatch(destroy(SOCIAL_RATE_QUERY));
  };

  handleSubmit = () => {
    this.props.dispatch(submit(SOCIAL_RATE_QUERY));
  };

  handleSocialRateQuery = values => {
    this.props.dispatch(accountActions.validateSocialRate(values.clientNumber, this.props.isPublicRequest));
  };

  handleBackToHome = () => {
    const route = this.props.isPublicRequest
      ? appConfig.publicDashboard.home
        ? ROUTES.PUBLIC_HOME
        : ROUTES.PUBLIC_PAYMENTS
      : ROUTES.ACCOUNT_STATUS;

    this.props.dispatch(push(route));
  };

  render() {
    const publicRequest = this.props.isPublicRequest || this.props.userAccounts.length === 0;
    return (
      <div style={styles.container}>
        <UTLabel bold large>
          {message('SocialRate:socialRateQuery')}
        </UTLabel>
        <SocialRateScene
          modalIsOpen={this.state.modalIsOpen}
          closeModal={this.handleQueryModalClose}
          handleSubmit={this.handleSubmit}
          onQueryButtonClick={this.handleQueryButtonClick}
          handleSocialRateQuery={this.handleSocialRateQuery}
          socialRateLoading={this.props.socialRateLoading}
          socialRateStatus={this.props.socialRateStatus}
          invalid={this.props.invalid}
          submitFailed={this.props.submitFailed}
          userAccounts={this.props.userAccounts}
          isPublicRequest={publicRequest}
          onGoToHome={this.handleBackToHome}
        />
      </div>
    );
  }
}

SocialRateContainer.propTypes = {
  socialRateLoading: bool,
  socialRateStatus: shape({
    address: string,
    message: string,
    social_rate: bool
  }),
  isPublicRequest: bool,
  invalid: bool,
  submitFailed: bool,
  userAccounts: accountPropTypes
};

const mapStateToProps = store => ({
  socialRateLoading: store.account.socialRateLoading,
  socialRateStatus: store.account.socialRateStatus,
  invalid: isInvalid(SOCIAL_RATE_QUERY)(store),
  submitFailed: hasSubmitFailed(SOCIAL_RATE_QUERY)(store),
  userAccounts: store.account.accounts
});

export default connect(mapStateToProps)(Radium(SocialRateContainer));
